import { render, staticRenderFns } from "./LegalLinks.vue?vue&type=template&id=5d4a7614&scoped=true&"
import script from "./LegalLinks.vue?vue&type=script&lang=ts&"
export * from "./LegalLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a7614",
  null
  
)

export default component.exports